import * as Types from '../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewStaffQuestionnaireStatusQueryVariables = Types.Exact<{
  accountListId: Types.Scalars['ID']['input'];
}>;

export type NewStaffQuestionnaireStatusQuery = { __typename?: 'Query' } & {
  newStaffQuestionnaire?: Types.Maybe<
    { __typename?: 'NewStaffQuestionnaire' } & Pick<
      Types.NewStaffQuestionnaire,
      'id' | 'completed'
    >
  >;
};

export const NewStaffQuestionnaireStatusDocument = gql`
  query NewStaffQuestionnaireStatus($accountListId: ID!) {
    newStaffQuestionnaire(accountListId: $accountListId) {
      id
      completed
    }
  }
`;

/**
 * __useNewStaffQuestionnaireStatusQuery__
 *
 * To run a query within a React component, call `useNewStaffQuestionnaireStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewStaffQuestionnaireStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewStaffQuestionnaireStatusQuery({
 *   variables: {
 *      accountListId: // value for 'accountListId'
 *   },
 * });
 */
export function useNewStaffQuestionnaireStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    NewStaffQuestionnaireStatusQuery,
    NewStaffQuestionnaireStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NewStaffQuestionnaireStatusQuery,
    NewStaffQuestionnaireStatusQueryVariables
  >(NewStaffQuestionnaireStatusDocument, options);
}
export function useNewStaffQuestionnaireStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewStaffQuestionnaireStatusQuery,
    NewStaffQuestionnaireStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NewStaffQuestionnaireStatusQuery,
    NewStaffQuestionnaireStatusQueryVariables
  >(NewStaffQuestionnaireStatusDocument, options);
}
export type NewStaffQuestionnaireStatusQueryHookResult = ReturnType<
  typeof useNewStaffQuestionnaireStatusQuery
>;
export type NewStaffQuestionnaireStatusLazyQueryHookResult = ReturnType<
  typeof useNewStaffQuestionnaireStatusLazyQuery
>;
export type NewStaffQuestionnaireStatusQueryResult = Apollo.QueryResult<
  NewStaffQuestionnaireStatusQuery,
  NewStaffQuestionnaireStatusQueryVariables
>;
